module.exports = __webpack_public_path__ + "static/augmentation-4d2b17e6f117a5c68547adef62a2a3e0.png";